import { hotjar } from 'react-hotjar'
import config from '../config'
import { debug } from '../utilities/logger'

if (config['vendor-activated']) {
  hotjar.initialize(config['hotjar-id'], config['hotjar-version'])
} else {
  debug(`[vendors][Hotjar] Deactivated cause not in production`)
}



// WEBPACK FOOTER //
// ./src/vendors/Hotjar.js